import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ClarityService {
  private loaded = false;

  constructor() { }

  load(): void {
    if (this.loaded) {
      return;
    }

    this.loaded = true;

    if (window.EveryBuddy.EnableClarity && !ClarityService.isAppleWebKitMobile()) {
      (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", "mufxo6jefz");

      console.log("Clarity enabled");
    } else {
      console.log("Clarity disabled");
    }
  }

  static isAppleWebKitMobile(): boolean {
    // This is true for most mobile browsers including Chrome, Safari and Edge.
    // Use to determine that we are on a mobile browser.
    const isMobile = /Mobile\/\w+/.test(navigator.userAgent);
    
    // True if mobile browser and vendor is Apple
    return isMobile && navigator.vendor.startsWith("Apple");
  }
}
